import { render, staticRenderFns } from "./ProjetoLei.vue?vue&type=template&id=46857824&scoped=true&"
import script from "./ProjetoLei.vue?vue&type=script&lang=js&"
export * from "./ProjetoLei.vue?vue&type=script&lang=js&"
import style0 from "./ProjetoLei.vue?vue&type=style&index=0&id=46857824&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46857824",
  null
  
)

export default component.exports